import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { CDK_ROW_TEMPLATE, CdkRow } from '@angular/cdk/table';

@Component({
  selector: 'mcrai-tr, a.mcrai-tr',
  template: CDK_ROW_TEMPLATE,
  styles: [`.mcrai-tr{display:flex;align-items:center;text-decoration:none;color:inherit}`],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: false,
  host: {
    '[class.mcrai-tr]': 'true'
  }
})
export class RowComponent extends CdkRow { }
